const MainPage = () => {
  return <h1>Main page</h1>;
};

export default MainPage;
